/**
 * Copyright 2025 Design Barn Inc.
 */

import type { FontOptions } from '../common';
import { LottieFontCommon } from '../common';

export class LottieFont extends LottieFontCommon {
  public constructor(options: FontOptions) {
    super(options);
  }
}
